module.exports = __webpack_public_path__ + "static/media/ring-gray.71cc52c2.svg";